import React, { useEffect, useState } from "react";
import { useGetMemoListQuery, usePostMemoMutation } from "@/redux/contractApi";
import Select from "react-select";
import { orderTypeOptions, contractStatusOptions } from "@/constants/selectOptions";

export const ContractMemo = ({ formData, handleChange, setFormData, contractGroupId }) => {
    const [memo, setMemo] = useState("");
    const [postMemo, { isLoading: isSaving }] = usePostMemoMutation();
    const { data: memoListData, refetch } = useGetMemoListQuery(contractGroupId, { skip: !contractGroupId });

    useEffect(() => {
        setMemo("");
    }, [contractGroupId]);

    const handleMemoChange = (e) => {
        setMemo(e.target.value);
    };

    const handleSaveMemo = async () => {
        if (!memo.trim()) {
            setFormData((prev) => ({ ...prev, toastMsg: "메모를 입력해주세요." }));
            return;
        }
        try {
            await postMemo({ contractGroupId, body: { content: memo } }).unwrap();
            setMemo("");
            refetch();
        } catch (e) {
            setFormData((prev) => ({ ...prev, toastMsg: e?.data?.message || "메모 저장 실패" }));
        }
    };

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>메모 히스토리</span>
                </div>
                <div className="row-content">
                    <div className="table-element">
                        <table>
                            <colgroup>
                                <col width="20%" />
                                <col width="20%" />
                                <col width="60%" />
                            </colgroup>
                            <tbody>
                                {memoListData?.data?.length > 0 ? (
                                    memoListData.data.map((item, idx) => (
                                        <tr key={item.id || idx}>
                                            <td>{item.createdAt?.slice(0, 10) || "-"}</td>
                                            <td>{item.writer.name || "-"}</td>
                                            <td>{item.content}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "left" }}>
                                            메모가 없습니다.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>메모</span>
                </div>
                <div className="row-content">
                    <div className="form-element" style={{ position: "relative", minHeight: "80px" }}>
                        <textarea
                            name="contractMemo.memo"
                            placeholder=""
                            value={memo}
                            onChange={handleMemoChange}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSaveMemo();
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="btn btn-xs btn-primary"
                            style={{ position: "absolute", bottom: 10, right: 10, height: "32px" }}
                            onClick={handleSaveMemo}
                            disabled={isSaving}
                        >
                            저장
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
